<template>
  <section
    class="component-ed6a5b36"
    resmed-component-name="custom-grid_mask_identifier"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center mb-4">
          <div class="col-md-8 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-html="acf.headline"></h2>
          </div>
        </div>
        <div class="row">
          <div
            v-for="(card, key) in acf.items"
            v-bind:data-key="key + 1"
            v-bind:class="{
              'step-1 col-md-6 col-lg-4 col-xl-4': key + 1 === 1,
              'step-2 col-md-6 col-lg-4 col-xl-4': key + 1 === 2,
              'step-3 col-md-6 col-lg-4 col-xl-4': key + 1 === 3,

              'step-4 col-md-6 col-lg-5 col-xl-4': key + 1 === 4,
              'step-5 col-md-12 col-lg-7 col-xl-8': key + 1 === 5,

              'step-6 col-md-12 col-lg-6 col-xl-6': key + 1 === 6,
              'step-7 col-md-12 col-lg-6 col-xl-6': key + 1 === 7,
            }"
          >
            <div
              class="card"
              v-bind:class="{
                'is-active': active.some((element) => {
                  return element === card.eyebrowicon.icon;
                }),
              }"
            >
              <!-- {{ key+1 }} -->
              <div class="number">
                <eyebrow-icon
                  v-if="card.eyebrowicon"
                  v-bind:eyebrowicon="card.eyebrowicon"
                ></eyebrow-icon>
              </div>

              <div class="content">
                <h2
                  v-html="card.title"
                  v-on:click.prevent="toggle(card.eyebrowicon.icon)"
                ></h2>
                <transition name="fade">
                  <div
                    v-if="
                      active.some((element) => {
                        return element === card.eyebrowicon.icon;
                      })
                    "
                  >
                    <div class="description">
                      <p>{{ card.description }}</p>
                    </div>
                    <div class="call-to-action">
                      <a
                        v-for="item in card.cta"
                        v-bind:href="item.cta.href"
                        v-bind:target="item.cta.target[0]"
                        class="btn cta-plain text-red icon right-arrow"
                        >{{ item.cta.text }}</a
                      >
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ed6a5b36", // custom-grid_mask_identifier
  props: ["acf"],
  data() {
    return {
      active: [],
      items: [],
    };
  },
  methods: {
    expand(arg) {
      this.active.push(arg);
    },
    toggle(key) {
      /**
       *
       * findIndex
       * --> not supported on IE11 <--
       *
       * let item = this.active.findIndex((element) => {
       *     return element === key;
       * });
       *
       */

      // use polyfill instead
      let item = -1;
      this.active.some((element, index) => {
        if (element === key) {
          item = index;
          return true;
        }
      });
      // end polyfill

      if (item === -1) {
        this.active.push(key);
      } else {
        this.active.splice(item, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ed6a5b36 {
  padding: 6rem 0 5rem 0;
  background-size: 45%;
  background-position: center 7rem;
  background-repeat: no-repeat;
  background-color: #f4faff; // default value
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NTYiIGhlaWdodD0iNjU0IiB2aWV3Qm94PSIwIDAgNjU2IDY1NCI+ICAgIDxlbGxpcHNlIGN4PSI3MjEiIGN5PSI0NjUiIGZpbGw9IiNFREY2RkUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iLjkiIHJ4PSIzMjgiIHJ5PSIzMjciIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTptdWx0aXBseSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM5MyAtMTM4KSIvPjwvc3ZnPg==);
}

.component {
  .row:first-of-type {
    h2 {
      position: relative;
      margin: 0 0 1rem 0;
      @extend %eyebrow-center;

      @media (min-width: 992px) and (max-width: 1200px) {
        font-size: 2rem;
      }
    }
  }

  [class*="step-"] {
    margin-bottom: 1.5rem;
  }

  .card {
    overflow: hidden;
    position: relative;

    background-color: $cc-resmed-white;
    box-shadow: 0 0.325rem 1.25rem 0 rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    border: 3px solid transparent;
    transition: all 1s;

    @media (min-width: 768px) {
      height: 308px;
    }

    .content {
      transition: all 0.5s ease;
      padding: 0 1.5rem 1.5rem 1.5rem;

      @media (min-width: 768px) {
        position: absolute;
        top: 12.5rem;
        padding: 0 2.25rem 0 2.25rem;
      }

      .btn {
        margin: 0.5rem 1rem 0 0;
      }
    }

    &:hover {
      transition: all 0.5s;
      border: 3px solid $cc-resmed-action-red;
    }

    &.is-active {
      border: 3px solid $cc-resmed-action-red;

      @media (min-width: 768px) {
        .content {
          transform: translateY(-6.5rem);
          top: 12rem;
        }
      }
    }

    .description {
      margin: 0.75rem 0 0.25rem 0;
    }

    .number {
      position: relative;
      margin-bottom: 1rem;
      padding: 2.25rem 1.5rem 0.875rem 1.5rem;

      @media (min-width: 768px) {
        padding: 2.25rem 2.25rem 0.875rem 2.25rem;
      }

      &:before {
        content: "";
        position: absolute;
        bottom: 0rem;
        left: 1.5rem;
        width: 1.25rem;
        height: 3px;
        background-color: $cc-resmed-black;

        @media (min-width: 768px) {
          left: 2.25rem;
        }
      }
    }
  }

  @media (max-width: 575px) {
    .step-2,
    .step-3 {
      .content {
        top: 14.375rem;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 992px) {
    .step-2,
    .step-3,
    .step-6 {
      .content {
        top: 14.375rem;
      }
    }
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    .step-5,
    .step-7 {
      .content {
        top: 10rem;
      }
    }
  }

  @media (min-width: 1200px) {
    .step-2,
    .step-3 {
      .content {
        top: 14.375rem;
      }
    }
  }

  .step-1 {
    //
  }

  .step-2 {
    //
  }

  .step-3 {
    //
  }

  .step-4 {
    //
  }

  .step-5 {
    h2 {
      @media (min-width: 1200px) {
        max-width: 480px;
      }
    }
  }

  .step-7 {
    h2 {
      @media (min-width: 1200px) {
        max-width: 460px;
      }
    }
  }
}
</style>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ed6a5b36 {
  .eyebrow-icon[class*="number-"] {
    background-size: 1rem 0.75rem;
    transform: translate(-0.125rem, 0);
  }

  .card {
    .content {
      h2 {
        position: relative;
        margin-bottom: 0;
        cursor: pointer;

        span {
          &:after {
            content: "";
            display: inline-block;
            margin-left: 0.5rem;
            transform: translateY(5px);
            width: 1.75rem;
            height: 1.75rem;
            border-radius: 50%;
            background-color: $cc-resmed-action-red;
            background-position: center center;
            background-repeat: no-repeat;
            background-image: url(#{$assets}/images/icon-move-expand-white.svg);

            @media (min-width: 992px) {
              transform: translateY(4px);
            }
          }
        }
      }
    }

    &.is-active {
      h2 {
        span {
          &:after {
            background-image: url(#{$assets}/images/icon-less-collapse-white.svg);
          }
        }
      }
    }
  }
}
</style>